import PedidoItemDetTipoEmbalagemService from "@/services/PedidoItemDetTipoEmbalagemService";

export const pedidoItemDetTipoEmbalagem = {
  namespaced: true,
  state: {
    pedidoItemDetTipoEmbalagem: {},
  },
  actions: {
    getPedidoItemDetTipoEmbalagem({ commit }, payload) {
      return PedidoItemDetTipoEmbalagemService.GetPedidoItemDetTipoEmbalagem(
        payload
      ).then(
        (pedidoItemDetTipoEmbalagem) => {
          return Promise.resolve(pedidoItemDetTipoEmbalagem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPedidoItemDetTipoEmbalagem({ commit }, payload) {
      return PedidoItemDetTipoEmbalagemService.PostPedidoItemDetTipoEmbalagem(
        payload
      ).then(
        (pedidoItemDetTipoEmbalagem) => {
          return Promise.resolve(pedidoItemDetTipoEmbalagem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPedidoItemDetTipoEmbalagem({ commit }, payload) {
      return PedidoItemDetTipoEmbalagemService.PutPedidoItemDetTipoEmbalagem(
        payload
      ).then(
        (pedidoItemDetTipoEmbalagem) => {
          return Promise.resolve(pedidoItemDetTipoEmbalagem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePedidoItemDetTipoEmbalagem({ commit }, payload) {
      return PedidoItemDetTipoEmbalagemService.DeletePedidoItemDetTipoEmbalagem(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPedidoItemDetTipoEmbalagemOData({ commit }, payload) {
      return PedidoItemDetTipoEmbalagemService.GetPedidoItemDetTipoEmbalagemOData(
        payload
      ).then(
        (pedidoItemDetTipoEmbalagem) => {
          return Promise.resolve(pedidoItemDetTipoEmbalagem);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default pedidoItemDetTipoEmbalagem;
